import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IconCloseSVG from 'component/svgComponents/close'
import translate from 'react-i18next/dist/commonjs/translate'
import WarningModal from 'component/scheduleBlock/WarningModal'

const MODAL_SIZES = ['sm', 'md', 'lg']

class SupplyModal extends Component {
  static propTypes = {
    noCloseOnConfirm: PropTypes.bool,

    buttonClass: PropTypes.string,

    /* Title of the modal */
    title: PropTypes.string,

    /* Determines the modal size */
    size: PropTypes.oneOf(MODAL_SIZES),

    /* Callback that will be triggered when the modal closes  */
    onCloseModal: PropTypes.func,

    /* Callback that will be triggered when the modal open  */
    onOpenModal: PropTypes.func,

    /* Callback that will be triggered when the modal is confirmed */
    onConfirm: PropTypes.func,

    /* Props children */
    children: PropTypes.object,

    contentBeforeChildren: PropTypes.object,

    /* Allow to render a child with close/confirm props */
    renderChildrenWithProps: PropTypes.func,

    /* Modal open button text */
    buttonText: PropTypes.string,

    /* Modal confirm button text */
    confirmButtonText: PropTypes.string || PropTypes.array,

    /* Confirmation types (danger or success) */
    confirmType: PropTypes.string,

    /* Modal confirm button disabled */
    isConfirmButtonDisabled: PropTypes.bool,

    /* Function for rendering a custom button */
    renderButton: PropTypes.func,

    /* String for btn cancel text */
    cancelButtonText: PropTypes.string,

    /* Bool that tells the modal if the header should be shown (default true) */
    showHeader: PropTypes.bool,

    /* Bool that tells the modal if the footer should be shown (default true) */
    showFooter: PropTypes.bool,

    /* Bool that tells the modal if it should be fixed open (default false) */
    isOpen: PropTypes.bool,

    /* Bool that tells the modal if it should disable the max-height (usefull for modals with selects) */
    disableMaxHeight: PropTypes.bool,

    /* Translation method */
    translate: PropTypes.func,

    /* If "visible" than the modal will not scroll the content */
    overflow: PropTypes.string,

    /* Bool that tells the modal if the content should be centered (default true) */
    center: PropTypes.bool,

    /* Disable bg click close */
    disabledBgClickClosing: PropTypes.bool,

    /* Hide cancel button */
    hideCancelButton: PropTypes.bool,

    /* Custom classname to modal */
    className: PropTypes.string,

    /* Allow to use the external isOpen */
    useControlledState: PropTypes.bool,

    disableClose: PropTypes.bool,

    hasValues: PropTypes.bool,
    
    downloadCsvModel: PropTypes.func,

  }

  static defaultProps = {
    size: 'md',
    confirmButtonText: 'Confirmar',
    isConfirmButtonDisabled: false,
    showHeader: true,
    showFooter: true,
    disableMaxHeight: false,
    className: '',
  }

  state = {
    /* Stores the information of wheter the modal is or not shown */
    isOpen: false,
    showWarningModal: false,
  }

  componentDidMount() {
    const { isOpen } = this.props
    if (isOpen) {
      this.setState({ isOpen })
    }
  }

  checkOpenState() {
    const { isOpen: stateOpen } = this.state
    const { isOpen, useControlledState = false } = this.props

    if (useControlledState && isOpen !== stateOpen) {
      this.setState({ isOpen })
    }
  }

  componentDidUpdate() {
  }

  onConfirm = () => {
    const { onConfirm = () => {}, noCloseOnConfirm } = this.props
    if (noCloseOnConfirm) onConfirm()
    else this.setState({ isOpen: false }, onConfirm)
  }

  onClose = () => {
    const { onCloseModal = () => {}, noCloseOnConfirm, disableClose, hasValues } = this.props
    
    if (disableClose) return
    
    if(hasValues) {
        this.setState({showWarningModal: true})
        return
    }
  
    if (noCloseOnConfirm) onCloseModal()
    else this.setState({ isOpen: false }, onCloseModal)
  }

  openModal = () => {
    const { onOpenModal = () => {} } = this.props
    this.setState({ isOpen: true }, onOpenModal)
    window.scrollTo(0, 0)
  }

  renderDefaultButton = () => {
    const { buttonText, onClick } = this.getButtonProps()
    return (
      <button className='open-modal-button' onClick={onClick}>
        {buttonText}
      </button>
    )
  }

  renderWarningModal = () => { 
    const {showWarningModal} = this.state
    const {translate, onCloseModal} = this.props
    if(!showWarningModal) return 
    return (
      <WarningModal
        customClass='pictogram-warning-modal irc-supply-warning-modal'
        handleCancel={() => this.setState({showWarningModal: false})}
        handleConfirm={() => {
            this.setState({showWarningModal: false}, () => {
                this.setState({ isOpen: false }, onCloseModal)
            })
        }}
        customText='Gostaria de sair sem salvar?'
        translate={translate}
        
      />
    )
  }


  getButtonProps = () => {
    const { buttonText } = this.props
    return { onClick: this.openModal, buttonText }
  }

  render() {
    const {
      buttonClass,
      center,
      overflow,
      title,
      size,
      renderButton,
      children,
      renderChildrenWithProps,
      isConfirmButtonDisabled,
      showHeader,
      showFooter,
      confirmType,
      disableMaxHeight,
      className,
      buttonText,
      disabledBgClickClosing,
      hideCancelButton,
      disableClose,
      contentBeforeChildren,
    } = this.props

    const { isOpen, showWarningModal } = this.state
    return (
      <>
        {this.renderWarningModal()}
        {(!renderButton && !buttonText) ||
          (renderButton
            ? renderButton(this.getButtonProps())
            : this.renderDefaultButton(this.getButtonProps()))}
        {isOpen && (
          <>
            <div style={{display: showWarningModal && 'none'}} className={`bg irc-supply-modal ${disableMaxHeight ? 'no-max-height' : ''}`}>
              <div
                className='bg-clickable'
                onClick={() => !disabledBgClickClosing && !disableClose && this.onClose()}
              />
              <div
                className={`custom-modal ${size} ${center && 'center'} ${
                  className || ''
                }`}
              >
                {showHeader && (
                  <div className='custom-modal-title'>
                    <h3>{title}</h3>
                    <i className='glyph glyph-times' />
                    <span
                      className='custom-modal-close-icon'
                      onClick={this.onClose}
                    >
                      <IconCloseSVG  />
                    </span>
                  </div>
                )}
                {contentBeforeChildren && <div>{contentBeforeChildren}</div>}
                <div
                  className={`custom-modal-content ${
                    overflow === 'visible'
                      ? 'overflow-visible'
                      : 'overflow-auto'
                  }`}
                >
                  {renderChildrenWithProps
                    ? renderChildrenWithProps({
                        onClose: this.onClose,
                        onConfirm: this.onConfirm,
                      })
                    : children}
                </div>
                {showFooter && (
                  <div className='custom-modal-footer'>
                    {!hideCancelButton && (
                      <button
                        className={`custom-modal-close-button ${buttonClass}`}
                        onClick={() => this.props.downloadCsvModel()}
                      >
                        Download do modelo de planilha
                      </button>
                    )}
                    <button
                      disabled={isConfirmButtonDisabled}
                      className={
                        confirmType === 'danger'
                          ? 'btn btn-danger'
                          : `custom-modal-confirm-button ${buttonClass}`
                      }
                      onClick={this.onConfirm}
                    >
                      Importar
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </>
    )
  }
}

export default translate(null, { wait: true, translateFuncName: 'translate' })(
  SupplyModal
)
